module.exports = __webpack_public_path__ + "img/solar-collector.496916ec.png";